import { createApp } from 'vue'
import App from './App.vue'

import router from './router'
window.$router = router
import store from './store'

import 'lib-flexible/flexible.js'
// import 'amfe-flexible'
// import 'lib-flexible'

import './assets/css/main.css'
import './assets/css/boder.css'
import './assets/css/public.css'
import '@/assets/iconfont/iconfont'

import api from '@/api';
import { wxConfig } from './utils/wx-config'
wxConfig(); //调用微信config 只需要在这里调用一次即可

/**自定义组件 */
import my_UI from '@/components/index.js'
import directives from '@/directives'

// import fastClick from 'fastclick'
// fastClick.attach(document.body)


function getQueryVariable(variable) {
  var query = window.location.href.split('?')[1]
  if (query) {
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (pair[0] == variable) { return pair[1]; }
    }
  }

  return (false);
}


const app = createApp(App)
app.use(router)
app.use(store)
app.use(my_UI)
app.use(directives) //todo...
app.config.globalProperties.api = api

import constants from './utils/constants'
import { openApp, WxAndMobile, getPlatForm } from './utils/common'
app.config.globalProperties.constants = constants
let docEl = document.documentElement

let platform = getPlatForm()
let isMobileWx = WxAndMobile()

app.config.globalProperties.ratio = docEl.clientWidth >= 540 ? 0.72 : docEl.clientWidth / 750
app.config.globalProperties.clientWidth = docEl.clientWidth
app.config.globalProperties.isMobileWx = isMobileWx
app.config.globalProperties.platform = platform
app.config.globalProperties.clientHeight = docEl.clientHeight
try {
  app.config.globalProperties.origin = getQueryVariable('origin')
  app.config.globalProperties.minOpenid = getQueryVariable('openid')
} catch (e) { }

app.config.globalProperties.window = {
  width: docEl.clientWidth,
  height: docEl.clientHeight
}
app.config.globalProperties.openApp = openApp

import { initCustomPlugin } from '@/components'
initCustomPlugin(app)

import VueWechatTitle from 'vue-wechat-title'
app.use(VueWechatTitle)
app.mount('#app')

// window.addEventListener('resize', fucntion () {
//   Mobile
// })


